import React, { Fragment } from 'react';
import { Button, Divider, Icon, Form } from 'antd';

import moment from 'moment';

import SelectedFilters from './SelectedFilters';

// Filter fields
import ServiceTypes from '../../../../common/FilterSections/ServiceTypes';
import Passengers from '../../../../common/FilterSections/Passengers';
import Arrival from '../../../../common/FilterSections/Arrival';
// import RequestTypes from '../../../../common/FilterSections/RequestTypes';
import WeekDays from '../../../../common/FilterSections/WeekDays';
import RouteLength from '../../../../common/FilterSections/RouteLength';
import RequestCreationPeriod from '../../../../common/FilterSections/RequestCreationPeriod';
import Clients from '../../../../common/FilterSections/Clients';

import './Filters.css';

class Filters extends React.PureComponent {
  getFilter = (name, form) => {
    switch (name) {
      case 'req_servtype':
        return <ServiceTypes key={name} form={form} />;
      case 'req_passqnt':
        return <Passengers key={name} form={form} />;
      case 'req_arrper':
        return <Arrival key={name} form={form} />;
      // case 'req_reqtype':
      //   return <RequestTypes key={name} form={form} />;
      case 'req_weekdays':
        return <WeekDays key={name} form={form} />;
      case 'req_rtlng':
        return <RouteLength key={name} form={form} />;
      case 'req_crper':
        return <RequestCreationPeriod key={name} form={form} />;
      case 'req_client':
        return <Clients key={name} form={form} />;
      default:
        return null;
    }
  };
  render() {
    const {
      showFilterAll, // не рефакторил
      showDrawer, // не рефакторил
      toggleAllFilter, // не рефакторил
      // работа с фильтрами
      form,
      settingsFilters,
      toggleVisibleMap,
      visibleMap,
      resetFilters,
      activeFiltersCount,
    } = this.props;
    
    let filters = settingsFilters ? settingsFilters : [];
    let otherFilters = [];
    if (filters.length > 5 && filters.length !== 6) {
      otherFilters = filters.slice(5);
      filters = filters.slice(0, 5);
    }

    return (
      <div className="b-table-filters b-table-filters_filters">
        <div className="b-table-filters__wrap-col">
          {filters.length > 0 && (
            <div className="b-table-filters__col3">
              <SelectedFilters resetFilters={resetFilters} activeFiltersCount={activeFiltersCount}/>
            </div>
          )}
          <div className="b-table-filters__col2">
            <Button
              className="orders__button-custom"
              type="link"
              onClick={toggleVisibleMap}
            >
              {visibleMap ? 'Закрыть карту' : 'Заявки на карте'}
              <Icon style={{ fontSize: '18px' }} type="environment" />
            </Button>
          </div>
          {filters.length === 0 && (
            <div className="b-table-filters__col2">
              <Button
                type="link"
                className="withIcon withIcon_setting right"
                onClick={showDrawer}
              >
                Настроить столбцы
                <Icon type="setting" />
              </Button>
            </div>
          )}
        </div>
        {filters && filters.map(key => this.getFilter(key, form))}
        {showFilterAll &&
          otherFilters &&
          otherFilters.map(key => this.getFilter(key, form))}
        {!showFilterAll && (
          <Fragment>
            {filters.length > 4 && otherFilters.length !== 0 && (
              <div className="b-table-filters__col">
                <Button
                  onClick={toggleAllFilter}
                  className="orders__button-custom"
                  type="link"
                >
                  Показать еще фильтры
                  <Icon style={{ fontSize: '12px' }} type="down" />
                </Button>
              </div>
            )}
          </Fragment>
        )}
        {showFilterAll && (
          <Fragment>
            <Divider style={{ height: 1, backgroundColor: '#d9d9d9' }} />
            <div className="b-table-filters__wrap-col">
              <div className="b-table-filters__col4">
                <Button
                  onClick={toggleAllFilter}
                  className="orders__button-custom"
                  type="link"
                >
                  Скрыть фильтры
                  <Icon style={{ fontSize: '12px' }} type="up" />
                </Button>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

class FiltersData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getValueByFieldName(name, val) {
    if (name.includes('Date')) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }

  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    // this.props.setForm(this.props.name, this.formRef);
  };

  render() {
    return (
      <FormOrderFilter
        {...this.props}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
      />
    );
  }
}

const FormOrderFilter = Form.create({
  name: 'requestFilters',
  onFieldsChange(props, changedFields) {
    props.handleFiltersChange(props.form.getFieldsValue());
  },
  mapPropsToFields(props) {
    let obj = {};
    props.filterData &&
      Object.keys(props.filterData).forEach(name => {
        obj[name] = Form.createFormField({
          value: props.getValueByFieldName(name, props.filterData[name]),
        });
      });
    return obj;
  },
  onValuesChange(props, values) {},
})(Filters);

export default FiltersData;
